import Signature from './src/Signature.vue'

export default Signature


// WEBPACK FOOTER //
// ./~/iexplore/components/signature/index.js